/*
  <virasat-tabs>: tab pills that switch panels (bestseller shelves, mood picker).
  Arrow keys, Home and End move between tabs. Optional [data-scroll-prev] / [data-scroll-next]
  buttons scroll the visible panel's [data-track] by one screen.
*/
if (!customElements.get('virasat-tabs')) {
  class VirasatTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = this.tabs.map((tab) => document.getElementById(tab.getAttribute('aria-controls')));

      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i));
        tab.addEventListener('keydown', (event) => this.onKey(event, i));
      });

      this.querySelector('[data-scroll-prev]')?.addEventListener('click', () => this.scroll(-1));
      this.querySelector('[data-scroll-next]')?.addEventListener('click', () => this.scroll(1));

      this.onBlockSelect = (event) => {
        const i = this.panels.findIndex((panel) => panel && panel.contains(event.target));
        const j = this.tabs.findIndex((tab) => tab.contains(event.target));
        if (i >= 0) this.select(i);
        else if (j >= 0) this.select(j);
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    select(index, focus = false) {
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (this.panels[i]) this.panels[i].hidden = !active;
      });
      if (focus) this.tabs[index].focus();
      const status = this.querySelector('[data-tab-status]');
      if (status) status.textContent = this.tabs[index].dataset.status || '';
    }

    onKey(event, index) {
      const last = this.tabs.length - 1;
      const keys = { ArrowRight: index + 1, ArrowLeft: index - 1, Home: 0, End: last };
      if (!(event.key in keys)) return;
      event.preventDefault();
      let next = keys[event.key];
      if (next > last) next = 0;
      if (next < 0) next = last;
      this.select(next, true);
    }

    scroll(direction) {
      const panel = this.panels.find((p) => p && !p.hidden);
      const track = panel?.querySelector('[data-track]');
      if (!track) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({ left: direction * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    }
  }

  customElements.define('virasat-tabs', VirasatTabs);
}
